<template>
  <div class="c-history">
    <div class="o-heading o-heading--bold o-heading--size-3 o-heading--section">
      {{ name }}
    </div>
    <div class="c-history__table-wrap" @scroll="loadMoreHistory">
      <table class="c-history__table o-table o-table--fixed">
        <thead>
          <tr class="c-history__row c-history__row--head">
            <th
              v-for="(value, name) in columns"
              :key="name.id"
              class="c-history__column-header"
              :class="`c-history__column--${name}`"
            >
              <span>{{ value }}</span>
            </th>
          </tr>
        </thead>
        <tbody v-for="item in history.items" :key="item.id">
          <tr tabindex="0" class="c-history__row" :class="item | eventToColor">
            <td class="c-history__item" v-if="item.profileEventType">
              {{
                translationsHistory.profileEvents[item.profileEventType] ||
                  item.profileEventType
              }}
              {{
                translationsHistory.ownerTypes[item.ownerType] || item.ownerType
              }}
            </td>
            <td class="c-history__item" v-else>
              {{
                translationsHistory.aedEvents[item.eventType] || item.eventType
              }}
            </td>
            <td class="c-history__item c-history__item--comment">
              <div v-if="item.changes">
                <div v-for="change in item.changes" :key="change.id">
                  <span>{{ change.fieldName }}</span>
                  <span v-if="change.index || change.index === 0"
                    >[{{ change.index }}]</span
                  >
                  <span>{{ translationsHistory.changeFrom }}</span>
                  <span>"{{ change.oldValue }}"</span>
                  <span>{{ translationsHistory.changeTo }}</span>
                  <span>"{{ change.newValue }}"</span>
                </div>
              </div>
              <div v-else>{{ item.comment }}</div>
            </td>
            <td class="c-history__item">
              <span>{{
                item.createdDateTime | formatDate("DD. MMM. YYYY - HH:mm")
              }}</span>
            </td>
            <td class="c-history__item">
              <span>{{ item.profileName || item.systemUserName }}</span>
            </td>
            <td class="c-history__item c-history__item--edit">
              <button
                class="o-button o-button--action o-button--round o-button--light"
                @click="editComment(item)"
                v-if="
                  (item.systemUserId === userInfo.Id &&
                    item.eventType === 'Comment') ||
                    [
                      'PendingMove',
                      'PendingMoveCancelled',
                      'PendingMoveRejected',
                      'MoveAedToAnotherFadder'
                    ].indexOf(item.eventType) >= 0
                "
              >
                <svg
                  class="o-svg-icon o-button__icon"
                  viewBox="0 0 64 64"
                  type="image/svg+xml"
                >
                  <use xlink:href="spritemap.svg#sprite-edit" x="0" y="0"></use>
                </svg>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <button class="o-button" @click="showModal = true">
      {{ translationsHistory.addComment || "" }}
    </button>
    <transition name="o-transition__modal">
      <CallCenterAEDModal v-if="showModal" @close="closeModal">
        <h2
          class="o-heading o-heading--size-2 o-heading--section o-heading--border"
          slot="header"
        >
          {{
            confirmation
              ? translationsHistory.areYouSureToDelete || ""
              : editModal
              ? translationsHistory.editComment || ""
              : translationsHistory.addComment || ""
          }}
        </h2>
        <div slot="body">
          <h4
            v-if="!confirmation"
            class="c-modal-comment__text-label o-heading o-heading--size-4 o-label o-label--block"
          >
            {{ translationsHistory.comment || "" }}
          </h4>
          <textarea
            v-if="!confirmation"
            class="c-modal-comment__text-area o-input o-input--modal"
            name="comment"
            :placeholder="translationsHistory.addCommentPlaceholder || ''"
            :maxlength="3000"
            v-model="comment"
            id=""
            cols="30"
            rows="10"
          ></textarea>
          <div v-if="!confirmation && editModal" class="c-modal-comment__note">
            {{ translationsHistory.aedEvents.Create }}
            {{ editableComment.createdDateTime | formatDate("DD-MM-YYYY") }}
            {{ translationsHistory.by }}
            {{ editableComment.systemUserName }}
          </div>
        </div>
        <div slot="footer">
          <div class="o-grid o-grid--gutter-small">
            <div class="o-grid__group">
              <div
                class="c-modal-comment__footer-item o-grid__item o-grid__item--grow-0"
              >
                <button class="o-button" @click="submitComment">
                  {{
                    confirmation
                      ? translationsHistory.deleteComment || ""
                      : editModal
                      ? translationsHistory.saveChanges || ""
                      : translationsHistory.addComment || ""
                  }}
                </button>
              </div>
              <div
                class="c-modal-comment__footer-item o-grid__item o-grid__item--grow-0"
              >
                <button
                  class="o-button o-button--transparent"
                  @click="confirmation ? (confirmation = false) : closeModal()"
                >
                  {{ translationsCustom.cancel || "" }}
                </button>
              </div>
              <div
                v-if="!confirmation && editModal"
                class="c-modal-comment__footer-item c-modal-comment__footer-item--delete o-grid__item o-grid__item--grow-0"
              >
                <button
                  class="o-button o-button--transparent"
                  @click="confirmation = true"
                >
                  <svg
                    class="o-svg-icon o-button__icon"
                    viewBox="0 0 64 64"
                    type="image/svg+xml"
                  >
                    <use
                      xlink:href="spritemap.svg#sprite-delete"
                      x="0"
                      y="0"
                    ></use>
                  </svg>
                  <span>{{ translationsHistory.deleteComment || "" }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </CallCenterAEDModal>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { debounce } from "lodash";
export default {
  name: "c-history",
  data() {
    return {
      section: "history",
      name: "Historik",
      pageNo: 1,
      showModal: false,
      editModal: false,
      comment: null,
      editableComment: null,
      confirmation: false
    };
  },
  computed: {
    ...mapGetters("aed", [
      "parameters",
      "history",
      "aedData",
      "fadder",
      "status",
      "serviceProvider"
    ]),
    ...mapState("authentication", ["userInfo"]),
    ...mapState("aed", ["loading"]),
    ...mapState("translations", {
      translationsHistory: "history",
      translationsCustom: "custom"
    }),
    columns() {
      let columns = {
        type: this.translationsHistory.type,
        comment: this.translationsHistory.comment,
        createdDate: this.translationsHistory.createdDate,
        createdBy: this.translationsHistory.createdBy,
        edit: ""
      };
      return columns;
    }
  },
  methods: {
    loadMoreHistory: debounce(function(event) {
      if (
        event.target.scrollTop + event.target.offsetHeight >
          event.target.children[0].scrollHeight * 0.95 &&
        !this.loading &&
        this.history.pages > this.pageNo
      ) {
        const { dispatch } = this.$store;
        const payload = {
          api: this.$api,
          section: this.section,
          id: this.$store.state.aed.all.id,
          parameters: JSON.parse(JSON.stringify(this.parameters))
        };
        this.pageNo += 1;
        payload.parameters["pageNo"] = this.pageNo;
        dispatch("aed/getMoreHistory", payload);
      }
    }, 500),
    submitComment() {
      const payload = {
        api: this.$api,
        id: this.$store.state.aed.all.id,
        section: this.section,
        data: {
          comment: this.comment
        }
      };
      const { dispatch } = this.$store;

      if (this.editModal && this.editableComment.eventId) {
        payload["itemId"] = this.editableComment.eventId;
        if (this.confirmation) {
          dispatch("aed/deleteHistoryItem", payload);
        } else {
          dispatch("aed/patchHistoryItem", payload);
        }
      } else {
        dispatch("aed/unshiftItem", payload);
      }
      this.closeModal();
    },
    editComment(comment) {
      this.editModal = this.showModal = true;
      this.comment = comment.comment;
      this.editableComment = comment;
    },
    closeModal() {
      this.editModal = this.showModal = this.confirmation = false;
      this.comment = this.editableComment = null;
    },
    updateHistory() {
      const { dispatch } = this.$store;
      const payload = {
        api: this.$api,
        section: this.section,
        id: this.$store.state.aed.all.id,
        parameters: this.parameters
      };
      this.pageNo = 1;
      dispatch("aed/getSection", payload);
    }
  },
  watch: {
    aedData() {
      this.updateHistory();
    },
    fadder() {
      this.updateHistory();
    },
    status() {
      this.updateHistory();
    },
    serviceProvider() {
      this.updateHistory();
    }
  }
};
</script>
<style lang="scss">
.c-history {
  &__table-wrap {
    max-height: 345px;
    overflow: auto;
    margin-bottom: toRem(30px);
  }

  &__row {
    border-bottom: 1px solid #e6e6e6;

    &.o-status {
      &--green {
        background-color: $s-cp-sup-green-status;
      }
      &--pink {
        background-color: $s-cp-sup-pink-status;
      }
    }
    &--head {
      @include setStyles("13", $s-typography-sizes);
      background: $s-cp-neutral-800;
      box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.14), 0 2px 2px 0 rgba(0, 0, 0, 0.12),
        0 1px 2px 0 rgba(0, 0, 0, 0.15);
    }
  }

  &__column-header {
    padding: toRem(12px 14px);
    position: sticky;
    top: 0;
    background: $s-cp-neutral-800;
    @include setStyles("13", $s-typography-sizes);
    div,
    span {
      @include setStyles("13", $s-typography-sizes);
    }
  }

  &__column {
    &--type {
      width: 20%;
    }
    &--comment {
      width: 40%;
    }
    &--createdDate {
      width: 15%;
    }
    &--createdBy {
      width: 20%;
    }
    &--edit {
      width: 5%;
    }
  }

  &__item {
    padding: toRem(15px 14px);
    color: $s-cp-neutral-300;
    overflow-wrap: break-word;
    @include setStyles("13", $s-typography-sizes);

    div,
    span {
      @include setStyles("13", $s-typography-sizes);
    }

    &:first-child {
      font-weight: 700;
      color: $s-cp-main;
    }

    &--comment {
      span {
        margin: 0 5px 0 0;
        &:first-child {
          font-weight: 700;
        }
        &:last-child {
          margin-right: 0;
        }
      }
    }
    &--edit {
      padding: toRem(0px 14px);
    }
  }
}
.c-modal-comment {
  &__text-area {
    resize: none;
    width: 100%;
    height: 165px;
  }

  &__note {
    margin: 15px 0 25px;
    color: $s-cp-neutral-400;
    @include setStyles("14", $s-typography-sizes);
  }
  &__footer-item {
    &--delete {
      margin-left: auto;

      .o-button {
        color: $s-cp-neutral-300;

        &__icon {
          fill: $s-cp-neutral-300;
        }
      }
    }
  }
}
</style>
